<template>
	<div class="NavBar">
		<div class="placeholder" v-if="fixed && placeholder"></div>
		<div
			class="navbar"
			:class="{
				fixed: fixed,
				shadow: shadow
			}"
		>
			<div class="left">
				<img src="@/assets/images/logo.png" class="logo" @click.stop="clickLogo" v-monitor="`logo`" />
			</div>
			<div class="right" @click.stop="goBack" v-monitor="home ? `返回首页` : `返回上一页`">
				<img v-if="!home && !$slots.icon" src="@/assets/images/return.png" class="return" />
				<slot name="icon"></slot>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * NavBar	顶部导航
 * @description	顶部导航
 *
 * @property {Boolean}			placeholder		是否开启占位符	(默认 true )
 * @property {Boolean}			fixed			是否保持顶部浮动	(默认 true )
 * @property {Boolean}			shadow			是否显示底部阴影	(默认 true )
 * @property {Boolean}			home			是否为首页，是则隐藏右侧返回按钮	(默认 false )
 *
 * @event    {Function}			click			点击组件时触发
 * @example  <nav-bar />
 */
export default {
	name: 'NavBar',
	props: {
		placeholder: {
			typeof: Boolean,
			default: true
		},
		fixed: {
			typeof: Boolean,
			default: true
		},
		shadow: {
			typeof: Boolean,
			default: true
		},
		home: {
			typeof: Boolean,
			default: false
		}
	},
	data() {
		return {};
	},
	created() {},
	mounted() {},
	methods: {
		clickLogo() {
			if (this.home && !this.$slots.icon) return;
			this.goHome();
		},
		goBack() {
			if (this.$slots.icon) {
				this.goHome();
			} else {
				this.backPage();
			}
		}
	}
};
</script>

<style lang="less" scoped>
.NavBar {
	width: 828px;

	& .placeholder {
		width: 828px;
		height: 110px;
		display: block;
	}

	& .navbar {
		width: 828px;
		height: 110px;
		background: @themeColor;
		position: fixed;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 101;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 36px;

		&.shadow {
			box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.04);
		}

		.left {
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		.right {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding: 15px;
			margin: -15px;
		}

		.logo {
			width: 267px;
			height: 61px;
			display: block;
		}

		.return {
			width: 38px;
			height: 38px;
			display: block;
			box-sizing: content-box;
		}
	}
}
</style>
